import { resolveSidebarNavColor } from '../../../app/shell/Sidebar/sidebarNavStyles';

const readNavigation = (view = null) => {
  if (view?.navigation && typeof view.navigation === 'object' && !Array.isArray(view.navigation)) {
    return view.navigation;
  }
  if (
    view?.properties?.navigation &&
    typeof view.properties.navigation === 'object' &&
    !Array.isArray(view.properties.navigation)
  ) {
    return view.properties.navigation;
  }
  return {};
};

const trimmedNonEmptyString = (value) => {
  if (typeof value !== 'string') return '';
  const t = value.trim();
  return t || '';
};

/**
 * Lucide-style icon token for sidebar / chrome (kebab-case e.g. `shopping-cart`).
 * Prefer published runtime `navigation`; fall back to `view_schema.display.icon`.
 */
export const getViewSidebarIconName = (view = null) => {
  const nav = readNavigation(view);
  const fromNav = trimmedNonEmptyString(nav.icon) || trimmedNonEmptyString(nav.symbol);
  if (fromNav) return fromNav;
  const schema = view?.view_schema ?? view?.viewSchema;
  const display = schema && typeof schema.display === 'object' && !Array.isArray(schema.display) ? schema.display : {};
  return trimmedNonEmptyString(display.icon);
};

/**
 * Sidebar accent color token (e.g. `green`, `blue`, `teal`).
 * Prefer published runtime `navigation.color`; fall back to `view_schema.display.color`.
 */
export const getViewSidebarColor = (view = null, fallbackIndex = 0) => {
  const nav = readNavigation(view);
  const fromNav = trimmedNonEmptyString(nav.color);
  if (fromNav) return resolveSidebarNavColor(fromNav, fallbackIndex);
  const schema = view?.view_schema ?? view?.viewSchema;
  const display = schema && typeof schema.display === 'object' && !Array.isArray(schema.display) ? schema.display : {};
  const fromDisplay = trimmedNonEmptyString(display.color);
  if (fromDisplay) return resolveSidebarNavColor(fromDisplay, fallbackIndex);
  return resolveSidebarNavColor(null, fallbackIndex);
};

export const isViewPublished = (view = null) => {
  if (view?.is_published !== undefined && view?.is_published !== null) {
    return Boolean(view.is_published);
  }
  return !Boolean(readNavigation(view)?.is_hidden);
};

export const getViewNavigationLabel = (view = null) =>
  readNavigation(view)?.label || view?.name || 'App';

export const getViewNavigationDescription = (view = null) =>
  readNavigation(view)?.description || view?.description || '';

export const sortViewsForNavigation = (views = []) =>
  [...views].sort((left, right) => {
    const leftNavigation = readNavigation(left);
    const rightNavigation = readNavigation(right);

    const leftOrder = Number.isFinite(leftNavigation?.order) ? leftNavigation.order : 0;
    const rightOrder = Number.isFinite(rightNavigation?.order) ? rightNavigation.order : 0;
    if (leftOrder !== rightOrder) {
      return leftOrder - rightOrder;
    }

    return getViewNavigationLabel(left).localeCompare(getViewNavigationLabel(right));
  });

export const getPublishedViews = (views = []) =>
  sortViewsForNavigation(views.filter((view) => isViewPublished(view)));
